import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1e265139: FaireBrandEntity = {
  token: "b_1e265139",
  type: "brand",
  name: "Woolzies",
  avatarUrl:
    "https://cdn.faire.com/fastly/42af705402d7a5771287c2405fabab2e4b8b5821c3402f5cdf61a1ba736ab9b0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b6cf0616ada8b16768d586dbb4585e89e6a66e8c183f3fdf8db355b70db504e2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/42af705402d7a5771287c2405fabab2e4b8b5821c3402f5cdf61a1ba736ab9b0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b6cf0616ada8b16768d586dbb4585e89e6a66e8c183f3fdf8db355b70db504e2.png",
  location: "NY, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 335,
  isInsider: true,
  description:
    "It All Started with Laundry.\n\nI’m Kathy, and I learned about natural home and wellness products when I realized the laundry was making my family sick. When I learned the harsh truth behind so-called fresh scented laundry detergent and dryer sheets, I decided things had to change. But I didn’t stop at laundry. And I didn’t stop at my family.\n\nAs I did my research about most home products, I realized the mass market was caught between innocent misinformation and downright false advertising. Beyond curious, I was now duty bound.\n\nThat led to the birth of our newest family member, Woolzies. A company sworn to make your linen closet a source of life, love and laughter.\n\nKathy",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:56.281Z",
    importedBy: "entity-db-cli",
  },
};
